import { render, staticRenderFns } from "./LuteinExtract.vue?vue&type=template&id=719526df&scoped=true&"
import script from "./LuteinExtract.vue?vue&type=script&lang=js&"
export * from "./LuteinExtract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719526df",
  null
  
)

export default component.exports